// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"PageTitle_titleContainer__3QYNi","title":"PageTitle_title__1Af0W","subtitle":"PageTitle_subtitle__1q2UR"};